import { css } from 'linaria';

export const fullWidthMobileButton = css`
  @media (--only-mobile) {
    width: 100%;
  }
`;
